import { Component, OnInit } from '@angular/core';
import { UsersService } from '../users.service'

@Component({
  selector: 'app-users-dashboard',
  templateUrl: './users-dashboard.component.html',
  styleUrls: ['./users-dashboard.component.css']
})
export class UsersDashboardComponent implements OnInit {
  _email: string
  _displayName: string
  editUserMode = false
  deleteUserMode = false
  isNew = false

  constructor(
    private users: UsersService
  ) { }

  ngOnInit() {
  }

  deleteUser(email) {
    let u = this.users.get(email)
    this.email=u['email']
    this.displayName=u['displayName']
    this.deleteUserMode = !this.deleteUserMode
  }

  cancelDelete() {
      this.email = ''
      this.deleteUserMode = false
  }

  confirmDelete() {
    this.deleteUserMode=false;
    let obs = this.users.deleteUser(this.email)
  }

  editUser(email) {
    this.isNew = false
    let u = this.users.get(email)
    this.email=u['email']
    this.displayName=u['displayName']
    this.editUserMode = !this.editUserMode
  }

  newUser() {
    this.isNew = true
    this.displayName=''
    this.email=''
    this.editUserMode = !this.editUserMode
  }



  saveUser() {
    if (!this.displayName)
      return alert("DISPLAY NAME MISSING")
    if (!this.email)
      return alert("EMAIL MISSING")
    if (this.email.indexOf('@') < 0 || this.email.indexOf('.') < 0)
      return alert("WRONG EMAIL")
    let obs = this.users.saveUser(this.email,
              this.displayName)
    obs.subscribe(resp => {
      this.isNew = false;
      this.editUserMode=false;
    })
  }

  get email() {
    return this._email
  }

  get displayName() {
    return this._displayName
  }

  set email(txt) {
    this._email = txt.trim()
  }

  set displayName(txt) {
    this._displayName = txt.trim()
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/users-dashboard/users-dashboard.component.ts